<script setup lang="ts">
type EventItem = {
  id: string;
  is_live: boolean;
  sport_name: string;
  sport_id: string;
  league_name: string;
  event_name: string;
  event_date: string;
  teams: any[];
  name?: string;
};

type SportItem = {
  id: string;
  name: string;
  league_name?: string;
  event_date?: string;
  event_name?: string;
  teams?: any[];
};

type LeagueItem = {
  id: string;
  name: string;
  sport_name: string;
  sport_id: string;
  region: string;
  order: number;
  league_name?: string;
  event_date?: string;
  event_name?: string;
  teams?: any[];
};

type Props = {
  category: string;
  data: EventItem | SportItem | LeagueItem;
};

const { data, category } = defineProps<Props>();

const { getLeagueImage, getEventDate, getSportImage } = useSportsBook();

const sportImage = computed<string>(() => {
  return getSportImage(data.id);
});

const leagueImage = computed<string>(() => {
  return getLeagueImage(data.league_name || '');
});

const { goToLocaleRoute } = useRoutes();

function goToPage() {
  let query = {};

  if (category === 'Events') {
    query = {
      eventId: data.id,
    };
  } else if (category === 'Leagues') {
    query = {
      leagueId: data.id,
    };
  } else if (category === 'Sports') {
    query = {
      sportId: data.id,
    };
  }

  return goToLocaleRoute({
    name: 'sports-sports',
    query,
  });
}

const matchFormatedDate = computed<string>(() => {
  return getEventDate(data?.event_date || '');
});
</script>

<template>
  <div :class="$style.widget">
    <section
      :class="$style.card"
      @click="goToPage()"
    >
      <div :class="$style.logo">
        <NuxtIcon
          :filled="category === 'Sports' ? false : true"
          :name="category === 'Sports' ? sportImage : leagueImage"
        />
      </div>

      <article
        v-if="category === 'Events'"
        :class="$style.competitors"
      >
        <p :class="$style.teams">
          {{ data?.event_name }}
        </p>
        <p :class="$style.league">
          {{ data.league_name }}
        </p>
      </article>
      <article
        v-else
        :class="$style.leagueInfo"
      >
        <p :class="$style.name">
          {{ data.name }}
        </p>
      </article>

      <div
        v-if="category === 'Events'"
        :class="$style.date"
      >
        <strong>
          {{ matchFormatedDate }}
        </strong>
      </div>
    </section>
  </div>
</template>

<style module lang="postcss">
.widget {
  @apply relative w-full py-2 px-3 rounded-md bg-texts/10 overflow-hidden;

  /*background-image: v-bind(logoImage);*/
}

.card {
  @apply w-full h-full flex justify-start items-center text-xs cursor-pointer;

  .logo {
    @apply relative h-10 w-10 rounded-full object-cover text-primary;
    svg {
      @apply w-10 h-auto;
    }
  }

  .competitors {
    @apply mb-1 ml-4 text-left leading-none;
    .teams {
      @apply mb-1 font-semibold text-texts line-clamp-2;
    }
    .league {
      @apply text-2xs font-bold text-texts/60 line-clamp-2;
    }
  }

  .date {
    @apply ml-auto min-w-20 px-0.5 float-right text-end text-texts/80 text-[.575rem] font-medium self-end;
  }

  .leagueInfo {
    @apply ml-4 text-left leading-none;
    .name {
      @apply mb-1 font-semibold text-texts line-clamp-2;
    }
  }
}
</style>
